export enum OrderStates {
  NUEVO= "nuevo",
  ENVIO_RECHAZADO= "envio rechazado",
  ERROR_AL_ENVIAR= "error al enviar"
}

export enum AxumOperationType {
  PRESUPUESTO= 2
}

export interface OrdersInitialState {
  fetchingOrders: number;
  errorMessage: string;
  success: boolean;
  orders: Order[];
  total: number,
  skip: number,
  take: number,
}

export interface Order {
  id: number,
  orderDate: string,
  organizationCode: string,
  originOrderId: string,
  originSystemCode: string,
  axumId: string,
  date: string,
  origin: string,
  sellerId: string,
  sellerName: string,
  clientId: string,
  clientName: string,
  channel: string,
  orderTotalNetPrice: number,
  orderTotalTaxes: number,
  orderTotalPerceptions: number,
  amount: number,
  state: string,
  receiptId: string,
  invoiceId: string,
  axumOperationType: string,
  detail: OrderDetail[],
  erpState: string
}

export interface OrderDetail {
  id: number,
  articleId: string,
  articleName: string,
  bundles: number,
  units: number,
  noFeeBundles: number,
  noFeeUnits: number,
  grossPrice: number,
  bonuses: string,
  taxes: number,
  netPrice: number,
}
